import React from "react";
import ct from "class-types.macro";
import { CategoryChildrenResult } from "~/common/Store/models/Category";
import NoScriptLazyImage from "~/common/NoScriptLazyImage";
interface Props {
  category: CategoryChildrenResult;
}
const CategoryGridItem = ({
  category
}: Props) => {
  return <a className={`ag-item ag-link ${ct("box-border", "block", "float-left", "p-4", "hover:shadow-inner-gray", "text-center")}`} href={category.link} title={category.name} data-sentry-component="CategoryGridItem" data-sentry-source-file="CategoryGridItem.tsx">
      <div className={ct("h-0", "m-0", "mb-2", "overflow-hidden", "pb-full", "relative")}>
        <NoScriptLazyImage src={category.image} alt={category.name} className={ct("absolute", "inset-0", "w-full")} dataTestId="categoryGridItemImage" data-sentry-element="NoScriptLazyImage" data-sentry-source-file="CategoryGridItem.tsx" />
      </div>
      <div>
        <p className={ct("font-semibold", "h-12", "text-xs", "leading-4", "mb-0", "max-h-full", "overflow-hidden", "sm:text-sm", "sm:leading-4")}>
          {category.name}
        </p>
        {category.childCount > 0 && <p className={ct("block", "text-2xs", "leading-4", "m-0", "relative", "text-gray-800", "uppercase")}>
            {`${category.childCount} ${category.childrenAreProducts ? "PRODUCTS" : "CATEGORIES"}`}
          </p>}
      </div>
    </a>;
};
export default CategoryGridItem;